
    import {defineComponent, reactive, ComputedRef, computed, nextTick, onMounted} from 'vue';
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";
    import { Tab, Tabs } from 'scvant';
    import  reportMsgUt from "@/util/reportMsg";

    interface State {
        checkItemsExplain: object[];
        activeName: string;
        reportMsg: object;
        reportDetectVersion: number;

    }
    export default defineComponent({
        name: "checkStandard",
        components: {
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
        },
        setup() {
            let state: State = reactive({
                activeName: '事故检测',
                checkItemsExplain: [],
                reportMsg: {},
                reportDetectVersion: 0
            })
            const {query} = useRoute();
            state.activeName = `${query.checkTitle}`;
            state.reportMsg = reportMsgUt;
            console.log('RpRC:', reportMsgUt.RpRC());
            let store = useStore();
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            let reportDetectVersion: ComputedRef<any> = computed<any>(() => store.state.reportDetectVersion)
            let newAccidentRule: ComputedRef<{}> = computed<{}>(() => (store.state.dataInfo as any).newAccidentRule);
            state.reportDetectVersion = reportDetectVersion.value as any;
            const {checkItemModules} = dataInfo.value as any;
            let checkItems: any = [];
            // 重大事故车判定标准
            let errStandardNew = '底大边内侧、底大边外侧、不可拆水箱框架、翼子板内骨架、后围板、导水槽、行李箱封边、车顶、车顶边、后翼子板等部位（详见下表列明的部件）存在切割；车身底板、行李箱底板、行李箱底板四边、纵梁、减震器座、行李箱隔板、防火墙、A/B/C/D柱内侧及封边、门槛梁存在钣金修复、严重变形、切割、锈蚀锈透、烧焊等缺陷认定为重大事故车。';
            let errStandardOld = '底大边内侧、底大边外侧、不可拆水箱框架、翼子板内骨架、后围板、导水槽、行李箱封边、车顶、车顶边、行李箱底板四边、C柱翼子板连接板、后翼子板存在切割；车身底板、行李箱底板、纵梁、减震器座、行李箱隔板、防火墙、A/B/C/D柱内侧及封边、门槛梁存在钣金修复、严重变形、切割、锈蚀锈透等缺陷认定为重大事故车。';
            let errStandardLast = '底大边内侧、底大边外侧、不可拆水箱框架、翼子板内骨架、后围板、导水槽、车顶、车顶边、后翼子板等部位（详见下表列明的部件）存在切割；车身底板、行李箱底板、纵梁、减震器座、行李箱后遮物板（铁质）、防火墙、A/B/C/D柱内侧及封边、门槛梁存在钣金修复、变形、切割、锈蚀锈透、烧焊等缺陷认定为重大事故车。';
            // 事故车判定标准
            let warnStandardOld = '底大边内侧、翼子板内骨架、不可拆水箱框架、导水槽等部位存在严重变形、钣金修复、烧焊等缺陷；前后灯框架存在切割、烧焊缺陷即认定为事故车。';
            let warnStandardLast = '底大边内侧、翼子板内骨架、不可拆水箱框架、导水槽等部位存在变形、钣金修复、烧焊等缺陷；即认定为事故车。';
            // 火烧车判定标准
            let fireStandardOld = '减震器座、发动机舱、车身线束、发动机舱内管路、行李箱舱等部位存在烟熏、碳化、受热变形任一情况，且单个部件缺陷面积大于等于0.3平方米，即认定为火烧车。';
            let fireStandardLast = '减震器座、发动机舱、车身线束、发动机舱内管路、行李箱舱等部位存在烟熏、碳化、受热变形、干粉残留任一情况，且单个部件缺陷面积大于等于0.3平方米，即认定为火烧车。';
            // 泡水车判定标准
            let waterStandardOld = '座椅滑轨、安全带、座椅坐垫底部、车顶篷、行李箱、保险丝盒、发动机舱、点烟器底座、地胶（毯）、转向柱、柱夹层及周边，驾驶室内控制单元等发现有明显的泡水迹象（例如：含泥沙、水印、锈蚀、霉斑等情况）若存在三种或大于三种情况的，即认定为泡水车（因潮湿导致的浮锈除外）。仅地胶（毯）、座椅滑轨、行李箱底板存在相应缺陷，不判定为泡水车，但是必须在报告在中注明。';
            let waterStandardLast = '座椅滑轨、安全带、座椅坐垫底部、车顶篷、行李箱、保险丝盒、点烟器底座、转向柱、柱夹层及周边，驾驶室内控制单元等发现有明显的泡水迹象（例如：含泥沙、水印、锈蚀、霉斑等情况）若存在三种或大于三种情况的，即认定为泡水车（因潮湿导致的浮锈除外）。仅主驾地毯（胶）、副驾地毯（胶）、后排地毯（胶）、座椅滑轨、行李箱底板存在相应缺陷，不判定为泡水车，并且主驾地毯（胶）、副驾地毯（胶）、后排地毯（胶）只算作一项但是必须在报告在中注明。';

            let exhpOldSrc = 'https://image.268v.com/20220704/png/cc00ab2dc232e3e5299b041bb7ca77fe.png?x-oss-process=image/resize,l_1000';
            let exhpNewSrc = 'https://image.268v.com/20230718/png/52945d2bc751d51ecab90404656c6075.png?x-oss-process=image/resize,l_1000';
            let checkItemsAll: any = [
                {
                    title: '事故检测',
                    code: 'Accident',
                    definitionList: [{
                        definitionTitle: '重大事故车定义：',
                        definition: '经过碰撞、维修不当、使用不当等非自然损耗因素造成严重损伤的机动车。',
                        standardTitle: '判定标准：',
                        standard: state.reportDetectVersion === 231107 ? errStandardLast : (newAccidentRule.value ? errStandardNew : errStandardOld),
                        show: 1
                    }, {
                        definitionTitle: '事故车定义：',
                        definition: '经过碰撞、维修不当、使用不当等非自然损耗因素造成一般损伤的机动车。',
                        standardTitle: '判定标准：',
                        standard: state.reportDetectVersion === 231107 ? warnStandardLast : warnStandardOld,
                        show: newAccidentRule.value
                    }],
                    standardImg: [
                        {
                            imgTitle: '前排',
                            imgList: [{
                                imgSrc: 'https://image.268v.com/20220704/png/aca583daf4c58eca3b7b91c040a9abb5.png?x-oss-process=image/resize,l_1000'
                            }
                            ]
                        },
                        {
                            imgTitle: '后排',
                            imgList: [
                                {
                                    imgSrc: newAccidentRule.value ? exhpNewSrc : exhpOldSrc,
                                    imgType: '两厢轿车'
                                },
                                {
                                    imgSrc:'https://image.268v.com/20220704/png/bbc24c43f1da80f23ededd5f5ec57219.png?x-oss-process=image/resize,l_1000',
                                    imgType: '三厢轿车'
                                },
                                {
                                    imgSrc:'https://image.268v.com/20220704/png/156fee1367c59c3c472a5e11918f2004.png?x-oss-process=image/resize,l_1000',
                                    imgType: 'SUV车型'
                                }
                            ]   
                        }
                    ]
                },
                {
                    title: '火烧检测',
                    code: 'Fire',
                    definitionTitle: '火烧车定义：',
                    definition: '车辆经燃烧、炙烤等高温作用，导致车辆部件受损或修复过后存在安全隐患的车辆。',
                    standardTitle: '判定标准：',
                    standard: state.reportDetectVersion === 231107 ? fireStandardLast : fireStandardOld,
                },
                {
                    title: '泡水检测',
                    code: 'SoakWater',
                    definitionTitle: '泡水车定义：',
                    definition: '因涉水或浸泡导致车舱内进水，并影响车辆电子元件的正常工作，存在安全隐患的车辆。',
                    standardTitle: '判定标准：',
                    standard: state.reportDetectVersion === 231107 ? waterStandardLast : waterStandardOld,
                },
                {
                    title: '安全检测',
                    code: 'Security',
                    definitionTitle: '安全检测定义：',
                    definition: '对车辆安全气囊及安全带检查是否有拆装痕迹、更换、召回更换等现象。',
                    standardTitle: '检测标准：',
                    standard: '如检测项中出现破损、故障、更换、脏污、拆装痕迹、改装、缺失、召回更换等缺陷状况，根据《268V检测认定标准》综合判断为安全缺陷。'
                },
                {
                    title: '外观检测',
                    code: 'Appearance',
                    definitionTitle: '外观检测定义：',
                    definition: '对车辆外观覆盖件检查，覆盖件主要由金属部件、塑料部件组成。',
                    standardTitle: '检测标准：',
                    standard: '检测项目中如出现剐蹭、划痕、变形、锈蚀、破损、更换、缝隙不均、拆装痕迹、钣金修复、雹子坑、腻子开裂、喷漆瑕疵、老化、胶体异常、掉（爆）漆、色差、重做漆、脏污、胶体开裂、封边不整、缺失、改装、故障、磨损、碎点、进水、撕裂等缺陷状况，根据《268V检测认定标准》综合判断为外观缺陷。'
                },
                {
                    title: '玻璃检测',
                    code: 'Glass',
                    definitionTitle: '玻璃检测定义：',
                    definition: '对车辆玻璃部位检查是否有腐蚀性损伤、更换、划痕等现象。',
                    standardTitle: '检测标准：',
                    standard: '如检测项中出现腐蚀性损伤、改装、更换、故障、划痕、卡滞、破损、碎点、异响等缺陷状况，根据《268V检测认定标准》综合判断为玻璃缺陷。'
                },
                {
                    title: '车灯检测',
                    code: 'CarLighting',
                    definitionTitle: '车灯检测定义：',
                    definition: '对车辆灯光部位检查是否有拆装痕迹、更换、划痕等现象。',
                    standardTitle: '检测标准：',
                    standard: '如检测项中出现拆装痕迹、改装、更换、故障、剐蹭、划痕、进水、老化、裂痕、喷漆瑕疵、破损、缺失等缺陷状况，根据《268V检测认定标准》综合判断为车灯缺陷。'
                },
                {
                    title: '内饰检测',
                    code: 'Interior',
                    definitionTitle: '内饰检测定义：',
                    definition: '对车辆驾驶室部件检查是否有缺失、磨损以及老化现象。',
                    standardTitle: '检测标准：',
                    standard: '如检测项中出现划痕、脏污、破损、更换、拆装痕迹、缝隙不均、改装、磨损、老化、缺失、烟头烫伤、故障、变形、修复痕迹等缺陷状况，根据《268V检测认定标准》综合判断为内饰缺陷。'
                },
                {
                    title: '电器检测',
                    code: 'Lighting',
                    definitionTitle: '电器检测定义：',
                    definition: '对车辆电器部件检查是否有破损、故障等现象。 ',
                    standardTitle: '检测标准：',
                    standard: '如果检测项目中各部件功能出现故障、异响、卡滞问题，根据《268V检测认定标准》综合判断为电器系统缺陷。'
                },
                {
                    title: '机舱检测',
                    code: 'Machine',
                    definitionTitle: '机舱检测定义：',
                    definition: '车辆静止状态下检查车辆发动机、变速箱等部件是否有破损、漏油、故障等现象。',
                    standardTitle: '检测标准：',
                    standard: '如检测项中出现漏油、渗油、异响、故障、液位高、液位低、变质、破损、老化、漏水、拆装痕迹、更换、改装、脏污、变形等缺陷状况，根据《268V检测认定标准》综合判断为机舱缺陷。'
                },
                {
                    title: '动力检测',
                    code: 'Power',
                    definitionTitle: '动力检测定义：',
                    definition: '车辆静止状态下检查车辆加速、转向、换挡是否正常。',
                    standardTitle: '检测标准：',
                    standard: '检测标准:如检测项中出现漏油、异响、缸体外部响、缸盖气门响、缸体内部响、故障、冒蓝烟、抖动、渗油、修复痕迹、冒黑烟、油改气、冒白烟、液位高、液位低、变质、破损、老化、漏水、换挡冲击、卡滞、闯挡、拆装痕迹、更换、缺失、改装、水温高等缺陷状况，根据《268V检测认定标准》综合判断为动力缺陷。'
                },
                {
                    title: '底盘检测',
                    code: 'Bottom',
                    definitionTitle: '底盘检测定义：',
                    definition: '检查车辆悬架系统、转向系统以及制动系统等部件是否正常。',
                    standardTitle: '检测标准：',
                    standard: '如检测项中出现划痕、锈蚀、变形、改装、磨损、破损、老化、更换、缺失、沉重、卡滞、漏油、异响、渗油、修复痕迹、故障、拆装痕迹、剐蹭、鼓包等缺陷状况，根据《268V检测认定标准》综合判断为底盘缺陷。'
                },
                {
                    title: '启动检测',
                    code: 'StartUp',
                    definitionTitle: '启动检测定义：',
                    definition: '对车辆启动系统检查是否存在无法启动以及启动困难等现象。',
                    standardTitle: '检测标准：',
                    standard: '如果检测项目中各部件存在故障、启动困难、无法启动等缺陷状况，根据《268V检测认定标准》综合判断为启动缺陷。'
                },
                
                {
                    title: '调表检测',
                    code: 'Adjust',
                    definitionTitle: '调表车定义：',
                    definition: '调表车是指篡改过真实里程数的车辆，表显里程与实际行驶里程不符，影响车辆新旧程度以及部件使用寿命的判断依据。',
                    standardTitle: '判定标准：',
                    standard: '车辆表显公里数与历史里程数据或OBD里程读数或车辆综合车况比对，存在异常的，差异大于10000公里（明显录入错误除外），即可判断为车辆存在调表。'
                },
                
            ];
            let checkAllCount = checkItemsAll.length;
            let checkCount = checkItemModules.length;
            for (let i=0;i<checkCount;i++){
                for(let j=0;j<checkAllCount;j++){
                    if(checkItemModules[i].itemCode === checkItemsAll[j].code) {
                        checkItems.push(checkItemsAll[j])
                    }
                }
            }
            
            let psLocalTitle = '附录';
            let psLocalContent = '事故车、水泡车、火烧车判定标准文件，国家标准GB/T30323-2013《二手车鉴定评估技术规范》，下载链接：https://cyd-prod.oss-cn-zhangjiakou.aliyuncs.com/1c0841d3e8eb92d39f61812ef091621c<br/>中国汽车流通协会团体标准T/CADA 18-2021《乘用车鉴定评估技术规范》，下载链接：https://cyd-prod.oss-cn-zhangjiakou.aliyuncs.com/2660d2c2d8f13b27d232de0f86514680';
            let ps: ComputedRef<string> = computed<string>(() => (store.state.dataInfo as any).ps);
            let psTitle: ComputedRef<string> = computed<string>(() => (store.state.dataInfo as any).psTitle);
            let appendix = {
                title: psTitle.value ? psTitle.value : psLocalTitle,
                code: 'Appendix',
                definition: ps.value ? ps.value : psLocalContent
            }
            checkItems.push(appendix);
            state.checkItemsExplain = checkItems;
            onMounted(() => {
                nextTick(() => {
                    let el: any = document.getElementById(state.activeName);
                    let top = el.offsetTop;
                    // console.log('top:', top);
                    window.scrollTo(0, top);
                });
            });
            return {
                state
            }
        },
        methods: {
            goBack(){
                history.go(-1)
            }
        }
    })
